import { render, staticRenderFns } from "./SectionMessages.vue?vue&type=template&id=4c4973e2"
import script from "./SectionMessages.vue?vue&type=script&lang=js"
export * from "./SectionMessages.vue?vue&type=script&lang=js"
import style0 from "./SectionMessages.vue?vue&type=style&index=0&id=4c4973e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports